import { render } from "./PullToRefresh.vue?vue&type=template&id=3dd836e0"
import script from "./PullToRefresh.vue?vue&type=script&lang=js"
export * from "./PullToRefresh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__